import { ActivatedRoute } from '@angular/router';
import { filter, identity, map, pickBy } from 'lodash';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, ReplaySubject, catchError, of, take } from 'rxjs';
import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';

import { StorageHelper } from '@diktup/frontend/helpers';
import { JobApplicationStatusEnum, JobDefinitionType, LandingPagesWithoutTranslationType, LandingPageTypeEnum } from '@sifca-monorepo/ecommerce-generator';

import { AppService, LandingPagesService, SeoService, SharedService } from '../../services';

@Component({
  template: '',
})
export class BaseCareerDetailsComponent implements OnInit {
  private fileInput;

  seo: any;
  appForm: FormGroup;
  posId: string = '';
  isCvUploaded = false;
  currentUserId: string;
  job: JobDefinitionType;
  isCoverUploaded = false;
  isButtonDisabled = false;
  landingPages: LandingPagesWithoutTranslationType[];

  constructor(
    protected renderer: Renderer2,
    protected metaTagService: Meta,
    protected appService: AppService,
    protected seoService: SeoService,
    protected titleTagService: Title,
    protected formBuilder: FormBuilder,
    protected sharedService: SharedService,
    protected storageHelper: StorageHelper,
    protected activatedRoute: ActivatedRoute,
    protected changeDetectorRef: ChangeDetectorRef,
    protected landingPagesService: LandingPagesService,
    @Inject(DOCUMENT) protected document: Document,
    @Inject(PLATFORM_ID) protected platformId: Object,
  ) {
    this.fileInput = this.document.createElement('input');
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
  }

  ngOnInit(): void {
    this.currentUserId = this.storageHelper.getData('currentUserId')
    this.seoService
        .getGeneralSEOJSON()
        .pipe(
          take(1),
          catchError(() => {
            return of(null);
          }),
        )
        .subscribe((res) => {
          this.seo = res;
          if (this.seo?.title) {
            this.titleTagService.setTitle(this.seo?.title);
          }
          this.sharedService.tags$ = [
            ...this.metaTagService.addTags(map(this.seo?.metas, (meta) => pickBy(meta, identity))),
            { charset: 'UTF-8' },
          ];
            this.sharedService.links$ = map(this.seo?.links, (seoLink) => {
              const link = this.renderer.createElement('link');
              if (seoLink.sizes) {
                link.sizes = seoLink.sizes;
              }
              if (seoLink.href) {
                link.href = seoLink.href;
              }
              if (seoLink.rel) {
                link.rel = seoLink.rel;
              }
              this.renderer.appendChild(this.document.head, link);
              return link;
            });
        });
    this.appService.jobDefinition(this.activatedRoute.snapshot.paramMap.get('id'))
    .pipe(
      catchError(() => {
        return of(null);
      }),
    )
    .subscribe();
    this.appService.job$.subscribe((res) => {
      this.job = res;
      this.changeDetectorRef.markForCheck();
    });
    this.landingPagesService.findLandingPagesByTargetAndTypePaginated([LandingPageTypeEnum.CONTACT, LandingPageTypeEnum.ABOUT])
    .pipe(
      catchError(() => {
        return of(null);
      }),
    )
    .subscribe((res) => {
      this.landingPages = filter(res.objects,(page) => page.pageType === LandingPageTypeEnum.ABOUT);
      this.changeDetectorRef.markForCheck();
    });
    this.appForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      message: ['', Validators.required],
      cv: ['', Validators.required],
      cover: ['', Validators.required],
      jobDefinition: [this.activatedRoute.snapshot.paramMap.get('id')],
      status: [JobApplicationStatusEnum.NEW],
    });
  }

  handleUpload(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {};
  }

  uploadCover(): void {
    this.fileInput.value = '';
    this.fileInput.value = '';
    this.fileInput.type = 'file';
    this.fileInput.name = 'file';
    this.fileInput.multiple = true;
    this.fileInput.style.display = 'none';
    // this.fileInput.onchange = async () => {
    //   this.appService.findContentTypeByType(this.fileInput.files[0].type)
    //   .pipe(
    //     catchError(() => {
    //       return of(null);
    //     }),
    //   )
    //   .subscribe((result) => {
    //     this.convertFile(this.fileInput.files[0])
    //     .pipe(
    //       catchError(() => {
    //         return of(null);
    //       }),
    //     )
    //     .subscribe((base64) => {
    //       if (base64) {
    //         const content: any = {
    //           owner: this.currentUserId,
    //           name: this.fileInput.files[0].name,
    //           size: this.fileInput.files[0].size,
    //           content: {
    //             type: result.id,
    //             base64,
    //           },
    //         };
    //         // this.appService.createDocument(content)
    //         // .pipe(
    //         //   catchError(() => {
    //         //     return of(null);
    //         //   }),
    //         // )
    //         // .subscribe((response) => {
    //         //   this.appForm.get('cover').patchValue(response.id);
    //         //   this.isCoverUploaded = true;
    //         // });
    //         this.changeDetectorRef.markForCheck();
    //       }
    //     });
    //   });
    // };
    this.fileInput.click();
  }

  uploadCV() {
    this.fileInput.value = '';
    this.fileInput.type = 'file';
    this.fileInput.name = 'file';
    this.fileInput.multiple = true;
    this.fileInput.style.display = 'none';
    // this.fileInput.onchange = async () => {
    //   this.appService.findContentTypeByType(this.fileInput.files[0].type)
    //   .pipe(
    //     catchError(() => {
    //       return of(null);
    //     }),
    //   )
    //   .subscribe((result) => {
    //     this.convertFile(this.fileInput.files[0])
    //     .pipe(
    //       catchError(() => {
    //         return of(null);
    //       }),
    //     )
    //     .subscribe((base64) => {
    //       if (base64) {
    //         const content: any = {
    //           owner: this.currentUserId,
    //           name: this.fileInput.files[0].name,
    //           size: this.fileInput.files[0].size,
    //           content: {
    //             type: result.id,
    //             base64,
    //           },
    //         };
    //         // this.appService.createDocument(content)
    //         // .pipe(
    //         //   catchError(() => {
    //         //     return of(null);
    //         //   }),
    //         // )
    //         // .subscribe((response) => {
    //         //   this.appForm.get('cv').patchValue(response.id);
    //         //   this.isCvUploaded = true;
    //         // });
    //         this.changeDetectorRef.markForCheck();
    //       }
    //     });
    //   });
    // };
    this.fileInput.click();
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    return result;
  }
  submitApplication() {
    this.appService.createJobApplication(this.appForm.value)
    .pipe(
      catchError(() => {
        return of(null);
      }),
    )
    .subscribe((res) => {
      if (res) {
        this.isButtonDisabled = true;
        this.changeDetectorRef.markForCheck();
      }
    });
  }
}
